import {Component, Inject, ViewChild} from '@angular/core';
import {CommonService} from '../../services/common.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import * as moment from 'moment';
import {FormGroup} from '@angular/forms';
import {LoadingService} from '../../services/loading.service';
import {MatStepper} from '@angular/material';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {AddRefrigeratorFirstStepComponent} from './first-step/add-refrigerator-first-step.component';
import {AddRefrigeratorSecondStepComponent} from './second-step/add-refrigerator-second-step.component';

moment.locale('el-GR');

@Component({
  styleUrls: ['./add-refrigerator-dialog.component.scss'],
  templateUrl: './add-refrigerator-dialog.component.html'
})
export class AddRefrigeratorDialogComponent {
  @ViewChild('stepper', {static: true}) stepper: MatStepper;
  @ViewChild('firstStep', {static: true}) firstStep: AddRefrigeratorFirstStepComponent;
  @ViewChild('secondStep', {static: true}) secondStep: AddRefrigeratorSecondStepComponent;

  public accessories: any;
  public checkDescription: string;
  private firstStepResult: any;
  public formGroup: FormGroup;
  public refrigeratorDetails: any;
  public refrigeratorKinds: any;
  public stock: any;
  public isLoading: boolean;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private matDialogRef: MatDialogRef<AddRefrigeratorDialogComponent>) {
    this.isLoading = false;
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public goBack(): void {
    this.stepper.previous();
  }

  public setButtonText(): string {
    return this.stepper.selectedIndex === 0 ? 'Επόμενο' : 'Καταχώρηση';
  }

  public setCardTitle(): string {
    return this.stepper.selectedIndex === 0 ? 'Βήμα 1' : 'Βήμα 2';
  }

  public async setSubmitAction(): Promise<void> {
    if (this.stepper.selectedIndex === 0) {
      this.firstStepResult = await this.firstStep.submit();
      this.refrigeratorDetails = this.firstStepResult.formGroup;
      this.checkDescription = this.firstStepResult.checkDescription;
      this.stock = this.firstStepResult.stock;
      if (this.stock.available_budget) {
        this.stepper.next();
      } else {
        this.toastMessagesService.toastMessages(this.stock.message);
      }
    } else {
      const request = this.secondStep.submit();
      const returnObject = this.firstStepResult.formGroup;
      returnObject.new_refrigerator_count = request.new_refrigerator_count;
      returnObject.used_refrigerator_count = request.used_refrigerator_count;
      returnObject.category_description = this.firstStepResult.category_description;
      returnObject.material_name = this.firstStepResult.material_name;
      this.matDialogRef.close(returnObject);
    }
  }

  public isFormGroupInvalid(): boolean {
    return this.stepper.selectedIndex === 0 ? this.firstStep && this.firstStep.isFormGroupInvalid()
      : this.secondStep && this.secondStep.isFormGroupInvalid();
  }
}
